import React from 'react';
import { Container, Title, Paper, Text } from '@mantine/core';

export const LoginHistoryPage: React.FC = () => {
  return (
    <Container size="xl">
      <Paper withBorder p="xl">
        <Title order={2} mb="md">Login History</Title>
        <Text c="dimmed">View recent login attempts to your account.</Text>
      </Paper>
    </Container>
  );
};